import React, { useState } from 'react';
import { Modal } from 'antd';
import DashboardHeader from '$components/ProductDashboard/DashboardHeader';
import DashboardSubheader from '$components/ProductDashboard/DashboardSubheader';
import ReferInput from '$components/UserAccount/ReferralRewards/ReferInput';
import styles from './styles.scss';

const IndividualReferral = (props) => {
  const { currentUser, product } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <DashboardHeader header="Refer and earn" />
      <DashboardSubheader>
        Give a friend $10 off; get a $10 gift card{' '}
        <span onClick={showModal} className={styles.terms}>
          (terms)
        </span>
      </DashboardSubheader>
      <ReferInput currentUser={currentUser} product={product} />
      <Modal
        title="Achievable referral program terms and conditions"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleOk}
      >
        <p>
          To qualify, your referee must purchase an Achievable course. Within 31 calendar
          days of your referee’s purchase, you will receive a $10 Amazon gift card. You
          cannot participate in pay-per-click advertising on trademarked terms, including
          any derivations, variations or misspellings thereof, for search or content-based
          campaigns on Google, MSN, or Yahoo. For the purposes of these terms, trademarked
          terms include Achievable and Achievable.me (all keywords apply as broad match).
        </p>
      </Modal>
    </div>
  );
};

export default IndividualReferral;
